const FEATURES = [
  { icon: 'ri-money-cny-circle-line', title: '完全免费', desc: '刃牙漫画全系列永久免费，无隐藏收费，不设VIP体系，想看多少看多少。' },
  { icon: 'ri-smartphone-line', title: '下拉式阅读', desc: '专为漫画阅读优化的下拉式浏览体验，手指一滑无缝衔接下一页，阅读不中断。' },
  { icon: 'ri-hd-line', title: '高清画质', desc: '全部漫画均为高清扫描版本，每一格分镜、每一条肌肉线条都清晰锐利还原。' },
  { icon: 'ri-stack-line', title: '全集收录', desc: '从最早的刃牙到最新的相扑道，正传外传一应俱全，一次收藏终身免费阅读。' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          为什么选择我们
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10 max-w-lg mx-auto">
          为刃牙漫画爱好者打造的极致阅读体验
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {FEATURES.map((f) => (
            <div key={f.title} className="bg-background-50 border border-background-200/80 rounded-xl p-5 md:p-6 text-center hover:border-primary-200/60 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 bg-primary-100 rounded-2xl flex items-center justify-center">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}